import React from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { DevTool } from '@hookform/devtools'
import { yupResolver } from '@hookform/resolvers/yup'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'

import { RecoveryPassword } from 'helpers'
import { forgetPassword } from 'services/auth'
import { Column, Text, NumberInput, Button, Link } from '../src/components'

const defaultValues = { document_number: '' }

const PasswordRecovery = () => {
  const {
    control,
    handleSubmit,
    errors,
    formState: { isSubmitting }
  } = useForm({
    resolver: yupResolver(RecoveryPassword),
    defaultValues
  })

  const router = useRouter()

  const onSubmit = async ({ document_number }) => {
    try {
      const { masked_email } = await forgetPassword({ document_number })
      router.push({
        pathname: '/feedback-recuperacao-senha',
        query: { email: masked_email }
      })
    } catch {
      toast.error('Ocorreu um erro ao solicitar a troca de senha')
    }
  }

  return (
    <Column alignItems='center' width='100%' pt='32vh' pl={2} pr={2}>
      <NextSeo title='Kavod Lending - Recuperar senha' description='KavodLending | Peer to Peer lending' />
      <form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: '384px' }}>
        <Text variant='h3' mb={2} styled={{ maxwidth: '384px' }}>
          Recuperar senha
        </Text>
        <Text variant='subtitle1' styled={{ maxWidth: '384px' }}>
          Digite o CPF associado à sua conta e enviaremos um link para redefinir sua senha
        </Text>
        <NumberInput
          styled={{ maxWidth: '384px' }}
          mt={5}
          mb='40px !important'
          id='document_number'
          name='document_number'
          inputType='cpf'
          control={control}
          error={errors.document_number}
        />
        <Button styled={{ maxWidth: '384px' }} width='100%' mb={2} type='submit' loader={isSubmitting}>
          Enviar
        </Button>
        <Column>
          <Link fontSize={14} href='/login' styled={{ maxWidth: '384px' }}>
            Ir para login
          </Link>
        </Column>
        <DevTool control={control} />
      </form>
    </Column>
  )
}

export default PasswordRecovery
